// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3ogrQ","divider":"styles_divider__1ivwZ","buttons":"styles_buttons__tJ1VB","button":"styles_button__2NFy4","hint":"styles_hint__1DstL"};